// src/components/Overlays/ErrorToast.jsx
import React, { useEffect, useRef } from 'react';

const ErrorToast = ({ isOpen, title, message, onClose }) => {
  const toastRef = useRef(null);

  useEffect(() => {
    if (isOpen && toastRef.current) {
      requestAnimationFrame(() => {
        toastRef.current.classList.remove('translate-y-full');
        toastRef.current.classList.add('translate-y-0');
      });
    }
  }, [isOpen]);

  const handleClose = () => {
    if (toastRef.current) {
      toastRef.current.classList.add('translate-y-full');
      toastRef.current.classList.remove('translate-y-0');
      setTimeout(() => {
        onClose();
      }, 300);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70]">
      <div className="absolute inset-0 bg-white bg-opacity-50 backdrop-blur-sm" onClick={handleClose}></div>
      <div
        ref={toastRef}
        className="fixed bottom-0 left-0 right-0 mx-auto transform translate-y-full transition-transform duration-300 ease-out cursor-pointer"
        onClick={handleClose}
      >
        <div className="ux-bg-dark-gray opacity-80 text-white shadow-xl p-8 min-h-[33svh] flex flex-col">
          <div className="flex items-center mb-3">
            <img src="./assets/static/EI.png" className="h-6 w-6 mr-3 flex-shrink-0" alt="エラーアイコン" />
            <h4 className="font-bold text-lg text-white">{title}</h4>
          </div>

          <hr className="border-t border-white mb-3" />

          <p className="leading-relaxed whitespace-pre-line">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorToast;